const SEARCH_CONTAINER_ID = "utilitySearchContainer";
const SEARCH_CANCEL_ID = "utilitySearchCancel";
const SEARCH_INPUT_ID = "utilitySearchInput";

const SEARCH_SHOW_CLASS = "utility-search-show";
const SEARCH_HIDE_CLASS = "utility-search-hide";
const SEARCH_TOGGLE_BTN_CLASS = "utility-search-toggle-btn";

let searchContainer = document.getElementById(SEARCH_CONTAINER_ID);
let searchToggle = Array.prototype.slice.call(document.querySelectorAll('.' + SEARCH_TOGGLE_BTN_CLASS));
let searchCancel = document.getElementById(SEARCH_CANCEL_ID);
let searchInput = document.getElementById(SEARCH_INPUT_ID);


export function searchState(clickCallback: () => void) {
    if (searchCancel) {
        let focusable = Array.prototype.slice.call(searchContainer.querySelectorAll('a, button, input'));
        focusable.forEach(element => {
            element.tabIndex = -1;
        });
        searchToggle.forEach(btn => {
            btn.addEventListener("click", toggleSearchContainer(clickCallback, focusable));
        });
        searchCancel.addEventListener("click", () => {
            closeSearchContainer();
            focusable.forEach(element => {
                element.tabIndex = -1;
            })
        });
    }
}

function toggleSearchContainer(callback, focusable) {
    return function () {
        if (searchContainer.classList.contains(SEARCH_SHOW_CLASS)) {
            closeSearchContainer();
        } else {
            openSearchContainer(focusable);
        }
        callback();
    }
}

function openSearchContainer(focusable) {
    searchContainer.classList.remove(SEARCH_HIDE_CLASS);
    searchContainer.classList.add(SEARCH_SHOW_CLASS);
    focusable.forEach(element => {
        element.tabIndex = 0;
    })
    searchInput.focus();
}

function closeSearchContainer() {
    searchContainer.classList.remove(SEARCH_SHOW_CLASS);
    searchContainer.classList.add(SEARCH_HIDE_CLASS);
    if (window.innerWidth > 1024) {
        searchToggle[0].focus();
    }
    else {
        searchToggle[1].focus();
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/utility-search.ts